<template>
  <div ref="targetEl">
    <slot v-if="shouldRender" />
  </div>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core';
import { nextTick, ref, useTemplateRef } from 'vue';

// https://medium.com/js-dojo/lazy-rendering-in-vue-to-improve-performance-dcccd445d5f

const props = defineProps<{
  renderOnIdle: boolean;
}>();

defineSlots<{
  default: unknown;
}>();

const shouldRender = ref(false);

const targetEl = useTemplateRef('targetEl');

const { stop } = useIntersectionObserver(
  targetEl,
  ([{ isIntersecting }]) => {
    if (isIntersecting) {
      shouldRender.value = true;
      stop();
    }
  },
  {
    rootMargin: '600px',
  },
);

if (props.renderOnIdle) {
  onIdle(() => {
    shouldRender.value = true;
    stop();
  });
}

function onIdle(cb = () => {}) {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(cb);
  } else {
    setTimeout(() => {
      nextTick(cb);
    }, 300);
  }
}
</script>
